/**
 * Import Lib & assets
 */

import React, { useContext } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

import { isOdd } from "helpers/tools/maths";
import { getProductUrl, getLocatorUrl } from "helpers/zodiac";

/**
 * import components
 */

import { Button__external } from "components/button/button";
import { ContentContext } from "context/contentContext";
import Button__disabled from "../../button/disabled/button__disabled";

/**
 * styled components
 */

const Footer = styled.div``;
const Row = styled.div`
  ${t.mixins.flex({ justify: "baseline" })}
`;
const Cell = styled.div`
  padding 0 6px;
  min-width: 200px;
  max-width: 200px;
  border-right: 1px solid ${t.color.greyGallery};
  
  ${t.mixins.sm(`
    min-width: 134px;
    max-width: 134px;
  `)}

  ${({ first }) =>
    first &&
    `
    position: absolute;
    left: 0;
    min-width: 159px;
    z-index: 2;
    ${t.mixins.rem(13, 14)}
    font-weight: ${t.font.bold};
    text-align: left;
  `}

  ${({ odd }) =>
    odd &&
    `
      ${t.mixins.sm(`
        background-color: ${t.color.lightGrey};
      `)}
    `}
`;
const HiddenCell = styled(Cell)`
  min-width: 159px;
  opacity: 0;

  ${t.mixins.sm(`
    display: none;
  `)}
`;
/**
 * footer component is..
 */

const Table__footer = ({ data }) => {
  const { c, lang } = useContext(ContentContext);
  return (
    <Footer>
      <Row>
        <Cell first />
        <HiddenCell />
        {data.map((item, index) => {
          const { id, url } = item;
          const product = `${url}`;
          const locator = getLocatorUrl(lang);
          const odd = isOdd(index);
          if (!url) {
            return (
              <Cell key={id} odd={odd}>
                <Button__disabled title={c("home.footer.coming_soon")} />
                <Button__external title={c("home.footer.locator")} href={locator} />
              </Cell>
            );
          }
          return (
            <Cell key={id} odd={odd}>
              <Button__external title={c("home.footer.product")} href={product} />
              <Button__external title={c("home.footer.locator")} href={locator} />
            </Cell>
          );
        })}
      </Row>
    </Footer>
  );
};

export default Table__footer;

Table__footer.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Table__footer.defaultProps = {
  style: {},
};

/*
    import Table__footer from 'components/table/footer/table__footer'
    <Table__footer />
  */
